<template>
<div v-if="pageData" class="c-mv6" :class="{'c-mv6--photo-right': isPhotoRight }">
  <div class="c-mv6__main">
    <span class="is-shape" :style="styleShape"></span>
    <img :src="pageData.photo.src" alt="" />
  </div>
  <div class="c-mv6__info">
    <div class="is-number"><img :src="iconFunction" alt="" width="124" height="124" /></div>
    <h2>
      <span v-for="line in pageData.info.title" :key="line">
        <span class="is-line">{{line}}</span>
      </span>
    </h2>
    <div class="is-text">
      <p v-html="pageData.info.text"></p>
      <a v-if="pageData.modal" class="c-btnView" href="#" @click.prevent="openModal">
        <span>VIEW MORE</span>
      </a>
    </div>
  </div>
</div>
</template>

<script>
import {gsap, Power3, Expo} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
      shapeSize: 880 / 720 * 100,
      isPhotoRight: false,
      iconFunction: '',
    }
  },
  props: ['name'],
  computed: {
    styleShape() {
      return {paddingTop: `${this.shapeSize}%`};
    }
  },
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // 写真のレイアウトclass
    this.isPhotoRight = (this.pageData.photo.layout === 'right');

    // Function番号
    this.iconFunction = `/catalogue/2023sp/assets/img/common/function${this.pageData.info.function}.svg`;

    // 画像
    const img = new Image();
    img.onload = () => {
      this.loaded({width: img.width, height: img.height});
    }
    img.src = this.pageData.photo.src;
  },
  methods: {
    once() {
      // 画像表示
      const photo = this.$el.querySelector('.c-mv6__main img');
      let viewPhoto = gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: 'top 90%',
          end: 'top 10%',
          once: true,
          // scrub: 0.7,
          // markers: true,
        }
      });
      viewPhoto.addLabel('start')
      .fromTo(photo, {
        scale: 1.3,
      }, {
        duration: 1.0,
        scale: 1,
        ease: Power3.easeOut,
      }, 'start')
      .fromTo(photo, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: Power3.easeOut,
      }, 'start+=0.1');

      // テキスト表示
      const blockText = this.$el.querySelector('.c-mv6__info');
      const number = blockText.querySelector('.is-number');
      const lines = blockText.querySelectorAll('.is-line');
      const texts = blockText.querySelector('.is-text');
      let viewText = gsap.timeline({
        scrollTrigger: {
          trigger: blockText,
          start: 'top 90%',
          end: 'top 40%',
          once: true,
          // scrub: true,
          // markers: true,
        }
      });
      viewText.addLabel('start')
      .fromTo(number, {
        opacity: 0,
      }, {
        duration: 1.0,
        opacity: 1,
        ease: 'none',
      }, 'start')
      .fromTo(lines, {
        opacity: 0,
        y: '20%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Power3.easeOut,
        stagger: 0.1,
      }, 'start')
      .fromTo(texts, {
        opacity: 0,
        y: '20%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Power3.easeOut,
      }, 'start+=0.2');

    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    loaded(e) {
      this.shapeSize = e.height / e.width * 100;
      this.$nextTick(this.once);
    },
  }
}
</script>